<script lang="ts">
	import type { Component } from "svelte"
	import { getLuxAiController } from "../LuxAIController.svelte"
	import { GenerateThemeController, setGenerateController } from "./GenerateController.svelte"
	import ThemeGeneration from "./ThemeGeneration.svelte"
	import { getProgressController } from "../ProgressHandler.svelte"
	import { Responsive } from "responsive"
	import { Toast } from "toaster"

	let luxAiController = getLuxAiController()

	const controller = new GenerateThemeController(
		luxAiController.api,
		{
			theme: luxAiController.selectedTheme,
			snapshot: luxAiController.selectedSnapshot,
			generation: luxAiController.selectedGeneration,
		},
		{
			goBack: () => {
				luxAiController.refreshActiveGenerations()
				luxAiController.view = "gallery"
			},
			onGenerationComplete: (sceneId) => {
				Toast.success("Scene generation complete!")
				luxAiController.quickActions.viewScene(sceneId)
				luxAiController.refreshActiveGenerations()
			},
			onGenerationStart: (gen) => {
				luxAiController.updateActiveGeneration(gen)
			},
			onError: (errorMessage: string) => {
				Toast.error(errorMessage)
				luxAiController.selectedGeneration = undefined
			},
		},
		getProgressController(),
	)
	setGenerateController(controller)
	let view = $derived(controller.view)
	const VIEWS: { [key in typeof view]: Component } = {
		themeGeneration: ThemeGeneration,
	}

	luxAiController.selectedGeneration = undefined

	let Comp = $derived(VIEWS[view])
</script>

<!-- generate theme flow

1. select or create an edited snapshot
2. generate and jump to scene

-->
<div class="generate" class:mobile={Responsive.isMobile}>
	<Comp />
</div>

<style>
	.generate {
		height: 100%;
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		overflow: hidden;
		align-items: center;
	}

	.generate :global(.heading) {
		flex-basis: max(10%, 4rem);
	}

	:global(.lux-ai) .generate :global(.heading) {
		width: 80%;
	}

	.generate :global(.heading h1) {
		margin-bottom: 0;
	}

	.generate :global(.heading p) {
		color: var(--color-text);
	}

	.generate :global(.preview-container) {
		min-height: 0;
		width: 80%;
		align-self: center;
	}

	.generate :global(.preview-container .img-container) {
		height: 100%;
		width: 100%;

		aspect-ratio: 16/9;
		overflow: hidden;
		border-radius: 0.25rem;
		position: relative;

		background-color: black;
	}

	.generate :global(.bottom-row) {
		flex-basis: max(10%, 4rem);
		display: flex;
		width: 100%;
	}

	.generate :global(.progress-preview) {
		display: flex;
		flex-direction: column;
		align-items: center;
		width: 80%;
	}

	.generate.mobile :global(.preview-container),
	.generate.mobile :global(.progress-preview) {
		width: 95%;
	}

	.generate :global(.progress-bar) {
		margin: 0.5rem 0;
	}
</style>
